import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { AbstractReactiveFormInput } from '../abstract-reactive-form-input';

@Component({
  selector: 'py-reactive-form-checkbox',
  templateUrl: './reactive-form-checkbox.component.html',
  styleUrls: ['./reactive-form-checkbox.component.scss'],
  standalone: false,
})
export class ReactiveFormCheckboxComponent extends AbstractReactiveFormInput implements OnInit {
  @Input()
  rounded?: boolean = false;

  @Input()
  group: UntypedFormGroup;

  @Input()
  fieldName: string;

  @Input()
  leftLabel?: string;

  @Input()
  rightLabel?: string;

  @Input()
  rightLabelIcon?: string;

  @Input()
  customLabelClass?: string = '';

  @Output()
  rightLabelIconOnClick = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit(): void {}

  toggle() {
    const control = this.group.controls[this.fieldName];
    control.markAsDirty();
    control.setValue(!control.value);
  }

  getField(): AbstractControl {
    return this.getGroup().get(this.fieldName);
  }

  getGroup(): UntypedFormGroup {
    return this.group;
  }

  isIncludeGroupErrors(): boolean {
    return false;
  }

  onClick() {
    this.rightLabelIconOnClick.emit();
  }
}
